import jyRequest from "../utils/axios";
// 获取类别
export function prjIntroGetAuditeProjectList(data) {
  return jyRequest.post({
    url: 'api/prjIntro/getAuditeProjectList',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

// 类别审核
export function prjIntroGetAuditeProject(data) {
  return jyRequest.post({
    url: 'api/prjIntro/auditeProject',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

// 获取用户
export function sysGetAuditeUserList(data) {
  return jyRequest.post({
    url: 'api/systemUser/getAuditeUserList ',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}


// 用户审核
export function sysGetAuditeUserAudite(data) {
  return jyRequest.post({
    url: 'api/systemUser/auditeUser',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}